var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvolux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4184_180073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.80541 0.549423L4.60666 2.27651H6.16708C6.24565 2.27352 6.32323 2.29484 6.38924 2.33757C6.45525 2.3803 6.50646 2.44236 6.5359 2.51527C6.56534 2.58818 6.57156 2.6684 6.55373 2.74498C6.53589 2.82156 6.49487 2.89077 6.43625 2.94317L5.08375 4.27484L5.83375 5.99734C5.86689 6.0764 5.87431 6.16388 5.85496 6.24739C5.83561 6.3309 5.79047 6.40621 5.72593 6.46263C5.6614 6.51906 5.58074 6.55374 5.49539 6.56176C5.41004 6.56979 5.32433 6.55075 5.25041 6.50734L3.44 5.48817L1.62541 6.50734C1.55154 6.55024 1.46606 6.56887 1.38103 6.5606C1.29601 6.55232 1.21573 6.51756 1.15151 6.46122C1.0873 6.40488 1.04239 6.3298 1.02313 6.24657C1.00387 6.16334 1.01123 6.07616 1.04416 5.99734L1.79416 4.27567L0.442496 2.94442C0.383859 2.89228 0.342719 2.82333 0.324678 2.74697C0.306637 2.6706 0.312572 2.59053 0.341675 2.51766C0.370778 2.44479 0.421634 2.38266 0.487318 2.33973C0.553002 2.2968 0.630321 2.27516 0.708746 2.27776H2.26791L3.06833 0.549423C3.10371 0.482341 3.15673 0.426188 3.22168 0.387018C3.28662 0.347849 3.36103 0.327148 3.43687 0.327148C3.51271 0.327148 3.58712 0.347849 3.65206 0.387018C3.71701 0.426188 3.77003 0.482341 3.80541 0.549423V0.549423Z",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64648 6.45801V7.91634",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91797 7.1875H9.3763",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8.02051V9.68717",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.85449H4.16667",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85547 0.3125V1.97917",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.02148 1.14551H9.68815",
    stroke: "#1FABBB",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4184_180073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvolux);
export default __webpack_public_path__ + "static/media/evolux.f6a488436894cbdbddd0d92086928976.svg";
export { ForwardRef as ReactComponent };